/**
 * @function initInViewport creates Intersection Observer instance for execute provided callback
 * when provided element is in observe field
 * @param {Object} element      element to observe
 * @param {Object} initCallback callback to execute
 */
function initInViewport( element, initCallback ) {
  const callback = ( entries, observer ) => {
    entries.forEach( ( entry ) => {
      if ( entry.isIntersecting ) {
        initCallback();
        observer.unobserve( entry.target );
      }
    } );
  };
  const observer = new window.IntersectionObserver( callback );

  observer.observe( element );
}

setTimeout( () => {
  Array.from( document.querySelectorAll( '.simple-post-slider' ) || [] )
    .forEach( ( slider ) => {
      initInViewport( slider, () => {
        const [ prev ] = slider.querySelectorAll( '.swiper-prev' );
        const [ next ] = slider.querySelectorAll( '.swiper-next' );
        const [ pagination ] = slider.querySelectorAll( '.swiper-pagination' );
        const [ swiper ] = slider.querySelectorAll( '.swiper-container' );
        const { default: defaultSlidesPerView, ...breakpoints } = JSON.parse( swiper.dataset.config );

        import( 'swiper' ).then( ( swiperModule ) => {
          const { Swiper, Navigation, Lazy, Pagination } = swiperModule;

          Swiper.use( [ Navigation, Lazy, Pagination ] );

          new Swiper( swiper, {
            slidesPerView: defaultSlidesPerView.slidesPerView,
            spaceBetween: 25,
            centeredSlides: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            lazy: true,
            loop: true,
            ...pagination && { pagination: {
              el: pagination,
              clickable: true,
            },
            },
            ...( next && prev ) && {
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
            },
            breakpoints,
          } );
        } );
      } );
    } );
}, 0 );

setTimeout( () => {
  Array.from( document.querySelectorAll( '.cvle-slider-advanced' ) || [] )
    .forEach( ( slider ) => {
      initInViewport( slider, () => {
        const dataset = slider.dataset;
        const [ swiper ] = slider.querySelectorAll( dataset.containerSelector );
        if ( ! swiper ) {
          return;
        }
        const [ prev ] = slider.querySelectorAll( '.swiper-prev' );
        const [ next ] = slider.querySelectorAll( '.swiper-next' );
        const [ pagination ] = slider.querySelectorAll( '.swiper-pagination' );
        const [ wrapper ] = swiper.children;
        const slides = Array.from( wrapper.children );
        const config = JSON.parse( dataset.swiperConfig );

        swiper.classList.add( 'swiper-container' );
        wrapper.classList.add( 'swiper-wrapper' );
        wrapper.classList.remove( 'wp-block-query-loop' ); // disalbe wp-block-query classes
        slides.forEach( ( slide ) => {
          slide.classList.add( 'swiper-slide' );
        } );

        import( 'swiper/bundle' ).then( ( swiperModule ) => {
          const { Swiper } = swiperModule;

          const swiperConfig = {
            spaceBetween: 25,
            centeredSlides: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            lazy: true,
            loop: true,
            ...pagination && { pagination: {
              el: pagination,
              clickable: true,
            },
            },
            ...( next && prev ) && {
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
            },
            ...config,
            on: {
              afterInit() {
                slider.classList.add( 'cvle-slider-advanced--initialized' );
              },
            },
          };

          const swiperSlider = new Swiper( swiper, swiperConfig );
          //add touch events for tablets and mobiles
          if ( next && prev && swiperSlider.params.loop === true ) {
            next.addEventListener( 'touchend', () => {
              swiperSlider.slideNext();
            } );

            prev.addEventListener( 'touchend', () => {
              swiperSlider.slidePrev();
            } );
          }
          // Autoplay stop button
          const sliderAutoplayButton = slider.querySelector( '.swiper-button-stop' );
          if ( sliderAutoplayButton ) {
            // Add class cc-swiper-stopped if some of controll btns were clicked.
            if ( swiperSlider.pagination.el && swiperSlider.pagination.el.hasChildNodes() ) {
              swiperSlider.pagination.el.childNodes.forEach( ( bullet ) => {
                bullet.addEventListener( 'click', () => {
                  // Add setTimeout for check if autoplay stopped after its stop.
                  setTimeout( () => {
                    if ( ! swiperSlider.autoplay.running ) {
                      sliderAutoplayButton.classList.add( 'cc-swiper-stopped' );
                    }
                  }, 100 );
                } );
              } );
            }
            if ( swiperSlider.navigation.nextEl ) {
              swiperSlider.navigation.nextEl.addEventListener( 'click', () => {
                sliderAutoplayButton.classList.add( 'cc-swiper-stopped' );
              } );
            }
            if ( swiperSlider.navigation.prevEl ) {
              swiperSlider.navigation.prevEl.addEventListener( 'click', () => {
                sliderAutoplayButton.classList.add( 'cc-swiper-stopped' );
              } );
            }
            // Add class cc-swiper-stopped if user tried or change slider via touch.
            slider.addEventListener( 'touchmove', () => {
              sliderAutoplayButton.classList.add( 'cc-swiper-stopped' );
            } );
            // Add class cc-swiper-stopped after toggle this button.
            sliderAutoplayButton.addEventListener( 'click', () => {
              if ( swiperSlider.autoplay.running ) {
                sliderAutoplayButton.classList.add( 'cc-swiper-stopped' );
                swiperSlider.autoplay.stop();
              } else {
                sliderAutoplayButton.classList.remove( 'cc-swiper-stopped' );
                swiperSlider.autoplay.start();
              }
            } );
          }
        } );
      } );
    } );
}, 0 );

setTimeout( () => {
  const [ swiper1 ] = document.querySelectorAll( '.swiper-1' );

  if ( swiper1 ) {
    initInViewport( swiper1, () => {
      import( 'swiper' ).then( ( swiperModule ) => {
        const { Swiper, Navigation, Lazy } = swiperModule;

        Swiper.use( [ Navigation, Lazy ] );

        new Swiper( swiper1, {
          slidesPerView: 1,
          spaceBetween: 25,
          centeredSlides: false,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          lazy: true,
          loop: true,
          navigation: {
            nextEl: '.slider-next-1',
            prevEl: '.slider-prev-1',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 2.7,
            },
            1740: {
              slidesPerView: 3.3,
            },
            2200: {
              slidesPerView: 4.2,
            },
          },
        } );
      } );
    } );
  }
}, 0 );

setTimeout( () => {
  const [ swiper2 ] = document.querySelectorAll( '.swiper-2' );

  if ( swiper2 ) {
    initInViewport( swiper2, () => {
      import( 'swiper' ).then( ( swiperModule ) => {
        const { Swiper, Navigation, Lazy } = swiperModule;

        Swiper.use( [ Navigation, Lazy ] );

        new Swiper( swiper2, {
          slidesPerView: 1,
          centeredSlides: false,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          loop: true,
          lazy: true,
          navigation: {
            nextEl: '.slider-next-2',
            prevEl: '.slider-prev-2',
          },
          breakpoints: {
            960: {
              slidesPerView: 1.3,
              spaceBetween: 120,
            },
            1740: {
              slidesPerView: 2.3,
              spaceBetween: 120,
            },
            2200: {
              slidesPerView: 2.5,
            },
          },
        } );
      } );
    } );
  }
}, 0 );

setTimeout( () => {
  const [ swiper3 ] = document.querySelectorAll( '.swiper-3' );

  if ( swiper3 ) {
    initInViewport( swiper3, () => {
      import( 'swiper' ).then( ( swiperModule ) => {
        const { Swiper, Navigation, Lazy } = swiperModule;

        Swiper.use( [ Navigation, Lazy ] );

        new Swiper( swiper3, {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 25,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          loop: true,
          lazy: true,
          navigation: {
            nextEl: '.slider-next-3',
            prevEl: '.slider-prev-3',
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              centeredSlides: false,
              spaceBetween: 25,
            },
            960: {
              slidesPerView: 4,
              centeredSlides: false,
              spaceBetween: 60,
            },
          },
        } );
      } );
    } );
  }
}, 0 );
